import React, { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import MenuMain from "../../components/frontend/MenuMain";
import axios from "../../utils/axiosInstance";

class Register extends Component {
  state = {
    formData: {
      full_name: "",
      phone: "",
      username: "",
      password: "",
      confirm_password: "",
      agree: false,
    },
    error: "",
    submitting: false,
    redirectToLogin: false,
  };

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: type === "checkbox" ? checked : value,
      },
    }));
  };

  handleCustomerSubmit = async (e) => {
    e.preventDefault();

    const { full_name, phone, username, password, confirm_password, agree } =
      this.state.formData;

    if (!full_name || !phone || !username) {
      return this.setState({
        error: "All fields except password are required.",
      });
    }

    if (!password || !confirm_password) {
      return this.setState({
        error: "Password and confirmation required.",
      });
    }

    if (password !== confirm_password) {
      return this.setState({
        error: "Passwords do not match.",
      });
    }

    if (!agree) {
      return this.setState({
        error: "You must agree to the terms & policy.",
      });
    }

    this.setState({ submitting: true, error: "" });

    try {
      await axios.post("/customers", {
        full_name,
        phone,
        username,
        password,
        confirm_password,
      });
      this.setState({ redirectToLogin: true });
    } catch (err) {
      console.error("❌ Registration error:", err);
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Server error while creating account.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  render() {
    const { formData, error, submitting, redirectToLogin } = this.state;

    // ✅ Safe redirect (NO crash)
    if (redirectToLogin) {
      return <Navigate to="/login" replace />;
    }

    return (
      <>
        <MenuMain />

        <main className="main pages">
          <div className="page-header breadcrumb-wrap">
            <div className="container">
              <div className="breadcrumb">
                <Link to="/" rel="nofollow">
                  <i className="fi-rs-home mr-5" />
                  Home
                </Link>
                <span /> Pages <span /> My Account
              </div>
            </div>
          </div>

          <div className="page-content pt-150 pb-150">
            <div className="container">
              <div className="row">
                <div className="col-xl-8 col-lg-10 col-md-12 m-auto">
                  <div className="row">
                    <div className="col-lg-12 col-md-12">
                      <div className="login_wrap widget-taber-content background-white">
                        <div className="padding_eight_all bg-white">
                          <div className="heading_s1">
                            <h1 className="mb-5">Create an Account</h1>
                            <p className="mb-30">
                              Already have an account?{" "}
                              <Link to="/login">Login</Link>
                            </p>
                          </div>

                          <form onSubmit={this.handleCustomerSubmit}>
                            <div className="form-group">
                              <input
                                type="text"
                                name="full_name"
                                placeholder="Full Name"
                                value={formData.full_name}
                                onChange={this.handleChange}
                                required
                              />
                            </div>

                            <div className="form-group">
                              <input
                                type="text"
                                name="phone"
                                placeholder="Phone"
                                value={formData.phone}
                                onChange={this.handleChange}
                                required
                              />
                            </div>

                            <div className="form-group">
                              <input
                                type="text"
                                name="username"
                                placeholder="Username"
                                value={formData.username}
                                onChange={this.handleChange}
                                required
                              />
                            </div>

                            <div className="form-group">
                              <input
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={formData.password}
                                onChange={this.handleChange}
                                required
                              />
                            </div>

                            <div className="form-group">
                              <input
                                type="password"
                                name="confirm_password"
                                placeholder="Confirm Password"
                                value={formData.confirm_password}
                                onChange={this.handleChange}
                                required
                              />
                            </div>

                            <div className="login_footer form-group mb-50">
                              <div className="chek-form">
                                <div className="custome-checkbox">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="agree"
                                    id="exampleCheckbox12"
                                    checked={formData.agree}
                                    onChange={this.handleChange}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="exampleCheckbox12"
                                  >
                                    <span>
                                      I agree to terms &amp; Policy.
                                    </span>
                                  </label>
                                </div>
                              </div>

                              <Link to="/privacy-policyml">
                                <i className="fi-rs-book-alt mr-5 text-muted" />
                                Learn more
                              </Link>
                            </div>

                            {error && (
                              <p className="text-danger mb-20">{error}</p>
                            )}

                            <div className="form-group mb-30">
                              <button
                                type="submit"
                                className="btn btn-fill-out btn-block hover-up font-weight-bold"
                                disabled={submitting}
                              >
                                {submitting
                                  ? "Creating Account..."
                                  : "Submit & Register"}
                              </button>
                            </div>

                            <p className="font-xs text-muted">
                              <strong>Note:</strong> Your personal data will be
                              used to support your experience throughout this
                              website, to manage access to your account, and for
                              other purposes described in our privacy policy.
                            </p>
                          </form>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    );
  }
}

export default Register;
